import React from 'react';

import * as formatters from '../../../utils/formatters';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function RoleDetails({ role }) {
    const { id, name, created_at, updated_at } = role;
    const { formatDateStringWithTimezone } = formatters;

    return (
        <Card title="Role details">
            <TableDetailsBody>
                <Row label="ID">{id}</Row>
                <Row label="Name">{name}</Row>
                <Row label="Created">{formatDateStringWithTimezone(created_at)}</Row>
                <Row label="Updated">{formatDateStringWithTimezone(updated_at)}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default RoleDetails;
